<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Datos Proyecciones de Ventas</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <button
            v-if="showCharts"
            class="btn base-button btn-neutral btn-sm mt-1"
            @click="resetCampaigns"
            v-text="'Cambiar Campañas'"
          ></button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div v-show="!showCharts" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Seleccione campañas a comparar</h3>
            </div>
            <div class="card-body">
              <campaign-select
                :key="`cu-c-select-${newSearch}`"
                v-model="currentCampaign"
                label="Seleccione campaña actual"
              />
              <campaign-select
                :key="`pr-c-select-${newSearch}`"
                v-model="previousCampaign"
                label="Seleccione campaña a comparar"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="showCharts" class="row justify-content-center">
        <div class="col-12">
          <card>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4">
                <h3>
                  Campaña Actual: <span class="font-weight-normal">{{ currentCampaignName }}</span>
                </h3>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <h3>
                  Campaña Previa: <span class="font-weight-normal">{{ previousCampaignName }}</span>
                </h3>
              </div>
              <div v-if="distributorName" class="col-12">
                <h3>
                  Distribuidor: <span class="font-weight-normal">{{ distributorName }}</span>
                  <span class="clean-search" @click="cleanDistributor()"><i class="fa fa-times"></i></span>
                </h3>
              </div>
              <div v-if="currentTableSearch" class="col-12">
                <h3>
                  Busqueda Actual: <span class="font-weight-normal">{{ currentTableSearch }}</span>
                  <span class="clean-search" @click="cleanSearch()"><i class="fa fa-times"></i></span>
                </h3>
              </div>
            </div>
          </card>
        </div>

        <projection-crop-chart
          :key="`crop-${newSearch}`"
          :current-campaign="currentCampaign"
          :previous-campaign="previousCampaign"
          @chartSearch="chartSearch = true"
        />
        <projection-variety-chart
          :key="`variety-${newSearch}`"
          :current-campaign="currentCampaign"
          :previous-campaign="previousCampaign"
          @chartSearch="chartSearch = true"
        />
        <projection-monthly-chart
          :key="`monthly-${newSearch}`"
          :current-campaign="currentCampaign"
          :previous-campaign="previousCampaign"
          @chartSearch="chartSearch = true"
        />
        <projection-state-chart
          :key="`state-${newSearch}`"
          :campaign="currentCampaign"
          @chartSearch="chartSearch = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ChartCampaignMixin from '@/mixins/chartCampaignMixin';
import ProjectionStateChart from './Charts/ProjectionStateChart';
import ProjectionCropChart from './Charts/ProjectionCropChart';
import ProjectionVarietyChart from './Charts/ProjectionVarietyChart';
import ProjectionMonthlyChart from './Charts/ProjectionMonthlyChart';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'ProjectionsCharts',
  components: {
    RouteBreadCrumb,
    CampaignSelect,
    ProjectionCropChart,
    ProjectionVarietyChart,
    ProjectionMonthlyChart,
    ProjectionStateChart,
  },

  mixins: [ChartCampaignMixin],

  data() {
    return {
      title: 'Gráficos proyecciones',
      newSearch: 0,
      chartSearch: false,
    };
  },

  computed: {
    previousCampaign: {
      get() {
        return this.previousCampaignId;
      },

      set(previousCampaign) {
        this.setPreviousCampaign(this.getCampaignById(previousCampaign));
      },
    },

    currentCampaign: {
      get() {
        return this.currentCampaignId;
      },

      set(currentCampaign) {
        this.setNavigationCampaign(currentCampaign);
        this.setCurrentCampaign(this.getCampaignById(currentCampaign));
      },
    },

    showCharts() {
      return this.currentCampaign && this.previousCampaign;
    },

    ...mapGetters('models/campaign', ['getCampaignById']),
    ...mapState('navigation', {
      navigationCampaignId: (state) => state.campaignId,
    }),

    ...mapState('models/projection', {
      currentTableSearch: (state) => state.currentTableSearch,
    }),
  },

  beforeCreate() {
    this.$loader.disable();
  },

  mounted() {
    if (this.navigationCampaignId && !this.currentCampaign) {
      this.currentCampaign = this.navigationCampaignId;
      this.newSearch++;
    }
  },

  beforeDestroy() {
    if (this.chartSearch) {
      this.$store.dispatch('models/projection/setCurrentTablePage', 1);
      this.$store.dispatch('models/order/setCurrentTablePage', 1);
    } else {
      this.clearChartFilters();
    }

    this.$loader.enable();
  },

  methods: {
    cleanDistributor() {
      this.setDistributor();
      this.newSearch++;
    },

    cleanSearch() {
      this.cleanCurrentTableSearch();
      this.newSearch++;
    },

    resetCampaigns() {
      this.previousCampaign = null;
      this.newSearch++;
    },

    ...mapActions('navigation', { setNavigationCampaign: 'setCampaign' }),
    ...mapActions('charts', ['clearChartFilters', 'setCurrentCampaign', 'setPreviousCampaign', 'setDistributor']),
    ...mapActions('models/projection', ['cleanCurrentTableSearch']),
  },
};
</script>

<style lang="scss" scoped>
.clean-search {
  cursor: pointer;
  margin: 0.5rem;
  padding: 0.5rem;

  &:hover {
    color: rgba(0, 0, 0, 0.5);
  }
}
</style>
